'use client';

import Script from 'next/script';
import { isBrowser } from '../../../utils/isBrowser';

export default function IZootoScript() {
  
  return (
    		<Script strategy='beforeInteractive' id='izooto-script' src="https://cdn.izooto.com/scripts/c7a0fd94b3925d18ff66ddfb9110ae008e6d6bc6.js" defer onLoad={(() => {
          if (!isBrowser()) return;
			// @ts-ignore
			window._izq = window._izq || []; window._izq.push(["init"])
		})}/>
  )
}
